module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-about-us"
  }, [(_vm.loading) ? _c('Loader') : _vm._e(), (!_vm.loading && _vm.props) ? _c('div', [_c('div', {
    staticClass: "brussing_section"
  }, [_c('div', {
    staticClass: "brussing_wrap"
  }, [(_vm.props.title.rendered) ? _c('h2', {
    staticClass: "brussing_title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.title.rendered)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "brussing_outer clearfix"
  }, [(_vm.props.brushing_and_flossing_content) ? _c('div', {
    staticClass: "brussing_left",
    domProps: {
      "innerHTML": _vm._s(_vm.props.brushing_and_flossing_content)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "brussing_right"
  }, [(_vm.props.brushing_and_flossing_right_img) ? _c('img', {
    attrs: {
      "src": _vm.props.brushing_and_flossing_right_img,
      "alt": ""
    }
  }) : _vm._e()])])])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b7c4296","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/faq/brushing-and-flossing/brushing-and-flossing.pug
// module id = 641
// module chunks = 1